import React, { useEffect, useState, useRef, useCallback } from "react";

import MqttClient from "lib/mqtt-client";
import { getAircareData, downloadAndExtractZip } from "utils";

const PageAlarm = ({ userInfo }) => {
  const prevUserInfoRef = useRef();

  const [alerts, setAlerts] = useState([]);
  const [lastAddedId, setLastAddedId] = useState(null);

  const handleMessage = useCallback((topic, message) => {
    console.log(message.toString());
    const id = Date.now();
    const newAlert = {
      id,
      time: new Date().toLocaleTimeString([], {
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      }),
      message: message.toString(),
    };
    setAlerts((prev) => [newAlert, ...prev]);
    setLastAddedId(id);
  }, []);

  useEffect(() => {
    const MQTT_BROKER = "ws://advapp.co.kr:9005";
    const client = new MqttClient(MQTT_BROKER);
    client.onMessage(handleMessage);
    client.connect("topic/proactive");

    return () => client.disconnect();
  }, []);

  useEffect(() => {
    const fetchAlarmAsync = async () => {
      if (userInfo) {
        const { path } = await getAircareData(userInfo.remoteUrl);
        if (path) {
          const files = await downloadAndExtractZip(path);
          const proactiveEntry = Object.entries(files).find(([fileName, _]) =>
            fileName.includes("proactive")
          );
          if (proactiveEntry) {
            const [proactiveFileName, proactiveData] = proactiveEntry;
            const newAlerts = proactiveData.history
              .map((entry) => ({
                id: new Date(entry.timestamp).getTime(),
                time: new Date(entry.timestamp).toLocaleString("ko-KR", {
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                }),
                message: entry.message,
              }))
              .reverse();

            setAlerts(newAlerts);
            setLastAddedId(newAlerts[0]?.id ?? null);
          }
        }
      }
    };

    const isDiff =
      !prevUserInfoRef.current ||
      JSON.stringify(prevUserInfoRef.current) !== JSON.stringify(userInfo);
    if (userInfo && isDiff) {
      prevUserInfoRef.current = userInfo;
      fetchAlarmAsync();
    }

    if (!userInfo) {
      setAlerts([]);
    }
  }, [userInfo]);

  return (
    <div
      style={{
        width: "420px",
        overflowY: "auto",
        backgroundColor: "#f6f6f6",
        padding: "2rem",
        paddingTop: "0.5rem",
        borderRadius: "1.5rem",
        margin: "1rem",
      }}
    >
      <h2
        style={{
          fontSize: "2rem",
          fontWeight: "bold",
          marginBottom: "1.5rem",
          color: "#000",
        }}
      >
        Proactive 알림 이력
      </h2>
      {alerts && (
        <ul
          style={{
            listStyleType: "none",
            padding: 0,
            paddingInlineStart: 0,
            margin: 0,
            display: "flex",
            flexDirection: "column",
            gap: "0.75rem",
          }}
        >
          {alerts.map((alert) => (
            <li
              key={alert.id}
              style={{
                margin: "0 auto",
                width: "100%",
                maxWidth: "90%",
                backgroundColor:
                  alert.id === lastAddedId ? "#7242EA" : "#ffffff",
                padding: "0.9rem",
                borderRadius: "0.75rem",
                boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                border: "1px solid #7242EA",
                color: alert.id === lastAddedId ? "#ffffff" : "#0f172a",
                fontSize: "1rem",
                animation:
                  alert.id === lastAddedId ? "slide-in 0.4s ease-out" : "none",
              }}
            >
              [{alert.time}] {alert.message}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default PageAlarm;
